import { slick } from "@accessible360/accessible-slick";

class Quotes {
    constructor(element) {
        this.el = element;
        if (!this.el) return;

        this.init();
    }

    init() {
        this.createCarousel();
    }

    createCarousel() {
        const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M10.6 21.3a1 1 0 0 1-1-1V3.4l-7.9 8A1 1 0 0 1 .3 9.8L9.9.3a1 1 0 0 1 1.4 0L21 9.9a1 1 0 0 1-1.5 1.4l-7.9-7.9v16.9c0 .5-.4 1-1 1Z" clip-rule="evenodd"/></svg>`;
        const props = {
            dots: false,
            arrows: true,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: false,
            arrowsPlacement: "afterSlides",
            prevArrow:
                '<button type="button" data-control-prev><span class="sr-text">Previous</span>' +
                arrow +
                "</button>",
            nextArrow:
                '<button type="button" data-control-next><span class="sr-text">Next</span>' +
                arrow +
                "</button>",
            responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }],
        };

        let carousel = $(this.el).slick(props);
        this.el.carousel = carousel;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const carousels = document.querySelectorAll("[data-carousel='quotes']");

    carousels.forEach((element) => {
        new Quotes(element);
    });
});

export default Quotes;
